import React, { useState } from "react";
import { CloudSlash, ArrowsClockwise, CloudArrowUp } from "@phosphor-icons/react";
import { useOfflineStatus } from "@/hooks/useOfflineStatus";
import { flushQueue } from "@/lib/offlineSync";
import { toast } from "sonner";

export default function OfflineBadge({ compact = false }) {
  const { online, pending } = useOfflineStatus();
  const [syncing, setSyncing] = useState(false);

  if (online && pending === 0) return null;

  const doSync = async () => {
    setSyncing(true);
    try {
      const r = await flushQueue();
      if (r?.offline) toast.error("Bağlantı yok");
      else if (r?.sent > 0) toast.success(`${r.sent} kayıt gönderildi`);
      else if (r?.failed > 0) toast.error(`${r.failed} kayıt reddedildi`);
      else toast("Kuyruk boş");
    } finally { setSyncing(false); }
  };

  return (
    <button
      onClick={doSync}
      disabled={syncing}
      data-testid="offline-badge"
      className={`inline-flex items-center gap-2 px-3 py-1.5 border font-bold uppercase tracking-widest text-[10px] transition ${
        !online
          ? "border-red-300 bg-red-50 text-red-700 hover:bg-red-100"
          : "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100"
      }`}
      title={
        !online
          ? "Çevrimdışısınız. Girişler cihazda kuyruklanacak."
          : `${pending} kayıt gönderim bekliyor. Şimdi göndermek için tıklayın.`
      }
    >
      {!online ? (
        <CloudSlash size={14} weight="duotone" />
      ) : syncing ? (
        <ArrowsClockwise size={14} weight="duotone" className="animate-spin" />
      ) : (
        <CloudArrowUp size={14} weight="duotone" />
      )}
      {!online ? (
        compact ? "Offline" : (pending > 0 ? `Offline • ${pending} kuyrukta` : "Offline")
      ) : (
        compact ? `${pending} kuyrukta` : `${pending} kayıt bekliyor · Şimdi Gönder`
      )}
    </button>
  );
}
